export default {
  auth: {
    clientId: process.env.VUE_APP_CLIENT_ID,
    authority:
      "https://login.microsoftonline.com/db864d39-6f92-4586-9073-7e7512028e2c",
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};
